export class DatosImportacionViewModel {
    tipo: number;
    sobrescribir: boolean;
    enviar: boolean;
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/models/viewmodels/datosImportacionViewModel.ts